let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("kgbtU"), load("ffEVr"), load("Wowvf"), load("hhss7"), load("4JUnA")]).then(() => parcelRequire('11cB0'));